import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const IonModalWrapper = styled(IonModal)`
  .error {
    font-size: 0.9em;
    color: var(--ion-color-danger);
  }
`;
